// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import messages from './messages';

type Props = {
  open: boolean,
  onClose: () => void,
  onConfirm: () => void,
  isConfirming: boolean,
  unit: ?string,
  transferDate: string,
};

// Dedicated confirmation modal for completing an active resident transfer (ENG-30151, OQ6). Matches
// the approved mockup: "Confirm Transfer" title + X close, three-paragraph body naming the
// destination Unit and Transfer Date, right-aligned Cancel (text) + Confirm (contained, loading
// while the mutation runs). "This action cannot be undone" carries no trailing period (per mockup).
function CompleteTransferModal({
  open,
  onClose,
  onConfirm,
  isConfirming,
  unit,
  transferDate,
}: Props) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={<FormattedMessage {...messages.completeTransferModalTitle} />}
      actionsProps={[
        {
          children: <FormattedMessage {...messages.completeTransferDismiss} />,
          onClick: onClose,
          variant: 'text',
          disabled: isConfirming,
        },
        {
          children: <FormattedMessage {...messages.completeTransferConfirm} />,
          submitButton: true,
          disabled: isConfirming,
          isSubmitting: isConfirming,
          onClick: onConfirm,
        },
      ]}
      ModalProps={{
        sx: {
          '.MuiPaper-root': {
            maxWidth: '600px',
            width: '100%',
          },
        },
      }}
    >
      <Stack direction={'column'} spacing={2}>
        <Typography variant={'bodyMedium'}>
          <FormattedMessage
            {...messages.completeTransferModalBody1}
            values={{ unit, transferDate }}
          />
        </Typography>
        <Typography variant={'bodyMedium'}>
          <FormattedMessage {...messages.completeTransferModalBody2} />
        </Typography>
        <Typography variant={'bodyMedium'}>
          <FormattedMessage {...messages.completeTransferModalBody3} />
        </Typography>
      </Stack>
    </Modal>
  );
}

export default CompleteTransferModal;
